/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchPostsSkeleton.defs.js'
export * as $defs from './searchPostsSkeleton.defs.js'
